import styled from 'styled-components'

export const RulerButton = styled.button<{selected: boolean; hover?: boolean}>`
  background: none;
  white-space: normal;
  box-sizing: border-box;
  color: ${({selected, theme}) => (selected ? theme.colors.primary : '#364152')};
  font-size: 14px;
  font-weight: ${({selected}) => selected && 'bold'};

  :hover {
    color: ${({hover, theme}) => hover && theme.hoverColors.primary};

    :not(:disabled) {
      text-shadow: 0px 0px 1px black;
    }
  }
  @media (max-width: 1500px) {
    font-size: 12px;
  }
`

export const CalendarButton = styled.button<{hideLabel?: boolean}>`
  background: none;
  font-weight: 500;
  border: ${({hideLabel}) => !hideLabel && '1px solid #9aa4b2'};
  border-radius: 8px;
  padding: ${({hideLabel}) => !hideLabel && '5px 20px'};
  line-height: 14px;
  height: 40px;
  color: ${({theme}) => theme.colors.text};
  @media (max-width: 1400px) {
    padding: 0px 10px;
  }
  @media (max-width: 460px) {
    padding: 0px 5px;
    height: 40px;
  }
`

export const ContainerInsideButton = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  @media (max-width: 1400px) {
    font-size: 12px;
  }
  @media (max-width: 460px) {
    gap: 4px;
  }
`
export const ResponsiveBox = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 20px;
  padding-right: 10px;

  @media (max-width: 460px) {
    padding-right: 0px;
  }
`

export const CalendarBox = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 332px;

  @media (max-width: 460px) {
    min-width: 200px;
    max-width: 250px;
  }
  @media (max-width: 400px) {
    min-width: 165px;
    max-width: 240px;
  }
`

export const InputBox = styled.div`
  display: flex;
  column-gap: 20px;
  max-width: 292px;
  min-width: 292px;

  @media (max-width: 460px) {
    max-width: 200px;
    min-width: 150px;
  }
  @media (max-width: 400px) {
    max-width: 175px;
    min-width: 150px;
  }
`
export const DateBox = styled.div`
  display: flex;
  border: 1px solid #9aa4b2;
  border-radius: 8px;
  padding: 0px 30px;
  height: 38px;
  align-items: center;
  column-gap: 20px;

  @media (max-width: 460px) {
    padding: 5px 15px;
    column-gap: 10px;
  }
`

export const ModalBox = styled.div`
  display: flex;
  padding: 15px;
  height: 100%;
  width: 100%;
  column-gap: 20px;

  @media (max-width: 460px) {
    padding: 0px;
    column-gap: 0px;
  }
`
